import {SxType} from "@baseTypes/sx/sxTypes";
import {SV_DARK, SV_LIGHT, SV_RADIUS_LG} from "@containers/singleVoyage/views/constants/theme";

export const sx: SxType = {
    root: {
        // opens right under the "change correction points" button, aligned to its right edge
        position: 'absolute',
        right: '15px',
        top: '64px',
        width: 'min(470px, calc(100% - 30px))',
        maxHeight: 'calc(100% - 80px)',
        zIndex: 55555,
        display: 'flex',
        flexDirection: 'column',
        borderRadius: SV_RADIUS_LG,
        border: '1px solid',
        overflow: 'hidden',
        cursor: 'default',
        '.lightTheme &': {
            // 85% opaque so the route underneath stays readable
            backgroundColor: 'rgba(255, 255, 255, 0.85)',
            backdropFilter: 'blur(4px)',
            borderColor: SV_LIGHT.line,
            boxShadow: SV_LIGHT.shadowMd,
            color: SV_LIGHT.text,
        },
        '.darkTheme &': {
            backgroundColor: 'rgba(28, 31, 36, 0.85)',
            backdropFilter: 'blur(4px)',
            borderColor: SV_DARK.line,
            boxShadow: SV_DARK.shadowMd,
            color: SV_DARK.text,
        },
    },
    header: {
        padding: '11px 8px 11px 15px',
        borderBottom: '1px solid',
        flexShrink: 0,
        '.lightTheme &': {
            borderColor: SV_LIGHT.line,
        },
        '.darkTheme &': {
            borderColor: SV_DARK.line,
        },
    },
    title: {
        fontSize: '16px',
        fontWeight: 700,
        lineHeight: '21px',
    },
    hint: {
        fontSize: '13px',
        lineHeight: '18px',
        '.lightTheme &': {
            color: SV_LIGHT.text2,
        },
        '.darkTheme &': {
            color: SV_DARK.text2,
        },
    },
    close: {
        '.lightTheme &': {
            color: SV_LIGHT.text2,
        },
        '.darkTheme &': {
            color: SV_DARK.text2,
        },
    },
    list: {
        overflowY: 'auto',
        padding: '7px',
        gap: '2px',
    },
}
